import axios from 'axios';
import safeLocalStorage from '../../shared/utils/safeLocalStorage';
const querystring = require('querystring');

const isProd = window.location.host == ('admin.hosman.co')
let BASE_URL = `${window.location.origin.replace('admin.', '')}/api/v1`;
if (isProd) BASE_URL = BASE_URL.replace('hosman.co', 'www.hosman.co')

const config = () => ({
  headers: {
    'Access-Control-Allow-Origin': '*',
    'X-Auth-Token': safeLocalStorage.getItem('token')
  }
});

const client = {
  get(path, params) {
    return axios.get(`${BASE_URL}${path}?${querystring.stringify(params)}`, config())
  },

  post(path, params) {
    return axios.post(`${BASE_URL}${path}`, params, config())
  },

  delete(path, data) {
    return axios.delete(`${BASE_URL}${path}`, { ...config(), data })
  },

  put(path, params) {
    return axios.put(`${BASE_URL}${path}`, params, config())
  },
}

export default client;
